import { StatusResult } from '../shared/enum/StatusResult';

export interface CompanyUploadResultModel {
    id: number,
    quantityInserted: number,
    quantityDuplicated: number,
    quotasQuantity: number,
    quotasInput: number,
    quantityTotal: number,  
    insertedQuotas: number,  
    quotaOverflow: boolean,
    registeredCompanysMessage: string;
    message: string,
    title: string,
    property: string,
    status: StatusResult
}

export const CompanyUploadResultInitial: CompanyUploadResultModel = {
    id: 0,
    quantityInserted: 0,
    quantityDuplicated: 0,
    quantityTotal: 0,
    quotasQuantity: 0,
    quotasInput: 0,
    insertedQuotas: 0,  
    quotaOverflow: false,
    message: '',
    title: '',
    property: '', 
    registeredCompanysMessage: '',
    status: StatusResult.DEFAULT
};